export var WishlistButtonType;
(function (WishlistButtonType) {
    WishlistButtonType["Default"] = "default";
    WishlistButtonType["WithOutline"] = "withOutline";
    WishlistButtonType["RemoveOnly"] = "removeOnly";
})(WishlistButtonType || (WishlistButtonType = {}));
